import React, { useEffect, useState } from "react";
import { getRoleById } from "../../../slices/admin/thunk";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useCurrentUser } from "../../../slices/auth/hooks";
import ProfileEmployee from "./Employee/ProfileEmployee";
import ProfileIndividual from "./Individual/ProfileIndividual";
import Swal from "sweetalert2";
import {
  deleteEmployeeByEmployerId,
  deleteIndividualById,
  editStatusEmployee,
  resendIndividualInvite,
} from "../../../slices/general/thunk";

const DashboardProfiles = () => {
  const currentuser = useCurrentUser();
  const dispatch = useDispatch();
  const { id, user } = useParams();
  const { role } = currentuser;

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();
  const [currentProfile, setCurrentProfile] = useState({});

  const isIndividual = currentProfile && currentProfile.individualCode;

  const getUserById = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRoleById({ role: user, id: id })
      ).unwrap();

      if (response.error) {
        Swal.fire("Error!", "Error", "error");
        return;
      }
      setCurrentProfile(response);
      setLoading(false);
    } catch (error) {
      console.log(error);
      Swal.fire("Error!", "Error", "error");
      setLoading(false);
      {
        user === "employee"
          ? navigate(`/${role}/employees`)
          : navigate(`/${user}`);
      }
    }
  };

  useEffect(() => {
    getUserById();
  }, []);

  const handleRefreshTable = () => {
    getUserById();
  };

  const handleTerminateEmployee = async (item) => {
    Swal.fire({
      title: `Are you sure you want to terminate the employee with email ${item.email}?`,
      text: "The employee will be terminated on next billing period.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, terminate",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Terminating employee..",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
          });

          const response = await dispatch(
            editStatusEmployee({
              employerId: item.employerId,
              employeeId: item.id,
              status: "deactivate",
            })
          ).unwrap();

          if (response.error) {
            Swal.fire({
              title: "Oops!",
              text: `There was a problem. Please try again later.`,
              icon: "error",
              confirmButtonText: "Ok",
            });

            return;
          } else {
            Swal.fire(
              "Success!",
              `Employee ${item.email} has been terminated successfully.`,
              "success"
            );
            handleRefreshTable();
          }
        } catch (err) {
          console.error(err);
          Swal.fire("Error!", err.message, "error");
        }
      }
    });
  };

  const handelReactivateEmployee = async (item) => {
    Swal.fire({
      title: `Are you sure you want to reactivate the employee with email ${item.email}?`,
      text: "The employee will be reactivated on next billing period.",
      icon: "warning",

      showCancelButton: true,
      confirmButtonText: "Yes, reactivate",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Reactivating employee..",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
          });

          const response = await dispatch(
            editStatusEmployee({
              employerId: item.employerId,
              employeeId: item.id,
              status: "reactivate",
            })
          ).unwrap();

          if (response.error) {
            Swal.fire({
              title: "Oops!",
              text: `There was a problem. Please try again later.`,
              icon: "error",
              confirmButtonText: "Ok",
            });

            return;
          } else {
            Swal.fire(
              "Success!",
              `Employee ${item.email} has been reactivated successfully.`,
              "success"
            );
            handleRefreshTable();
          }
        } catch (err) {
          console.error(err);
          Swal.fire("Error!", err.message, "error");
        }
      }
    });
  };

  const handleRemoveUser = async (item) => {
    Swal.fire({
      title: `Are you sure you want to remove ${
        item.individualCode ? "Individual" : "Employee"
      } with email ${item.email}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Deleting...",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
          });

          const actionToDispatch = item.individualCode
            ? deleteIndividualById({ individualId: item.id })
            : deleteEmployeeByEmployerId({
                employerId: item.employerId,
                employeeId: item.id,
              });

          const response = await dispatch(actionToDispatch).unwrap();

          if (response.error) {
            Swal.fire({
              title: "Oops!",
              text: `There was a problem deleting the ${
                item.individualCode ? "individual" : "employee"
              }: ${response.error}.`,
              icon: "error",
              confirmButtonText: "Ok",
            });

            return;
          } else {
            Swal.fire(
              "Deleted!",
              `${item.individualCode ? "Individual" : "Employee"} ${
                item.email
              } has been deleted successfully.`,
              "success"
            );
          }
          navigate(`/${role}/employees`);
        } catch (err) {
          console.error(err);

          Swal.fire("Error!", errorMessage, "error");
        }
      }
    });
  };

  const handleResendInvite = async (item) => {
    Swal.fire({
      title: `Are you sure you want to resend the invite to ${item.email}?`,
      text: "The invite will be resent to the individual.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, resend",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          Swal.fire({
            title: "Resending invite..",
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showConfirmButton: false,
          });

          const response = await dispatch(
            resendIndividualInvite({ individualId: item.id })
          ).unwrap();

          if (response.error) {
            Swal.fire({
              title: "Oops!",
              text: `There was a problem. Please try again later.`,
              icon: "error",
              confirmButtonText: "Ok",
            });

            return;
          } else {
            Swal.fire(
              "Success!",
              `Invite has been resent to ${item.email} successfully.`,
              "success"
            );
          }
        } catch (err) {
          console.error(err);
          Swal.fire("Error!", err.message, "error");
        }
      }
    });
  };

  return (
    <div>
      {!isIndividual ? (
        <ProfileEmployee
          employee={currentProfile}
          loading={loading}
          setEmployee={setCurrentProfile}
          onTerminate={handleTerminateEmployee}
          onReactivate={handelReactivateEmployee}
          onDelete={handleRemoveUser}
          onRefreshTable={handleRefreshTable}
        />
      ) : (
        <ProfileIndividual
          onRefreshTable={handleRefreshTable}
          individual={currentProfile}
          onDelete={handleRemoveUser}
          setIndividual={setCurrentProfile}
          loading={loading}
          onResendInvite={handleResendInvite}
        />
      )}
    </div>
  );
};

export default DashboardProfiles;
